import { useObserver } from "mobx-react-lite";
import { useStores } from "@stores";

const useDeadline = () => {
  const { settingsStore } = useStores();
  return useObserver(() => settingsStore.dictionary);
};

export default useDeadline;
